import { render } from "./about-nbusiness.vue?vue&type=template&id=325c3ea0&scoped=true"
import script from "./about-nbusiness.vue?vue&type=script&lang=js"
export * from "./about-nbusiness.vue?vue&type=script&lang=js"

import "./about-nbusiness.vue?vue&type=style&index=0&id=325c3ea0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c3ea0"]])

export default __exports__